import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "../../lib/api";
import { Logo } from "../../components/Logo";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset successful. Please sign in.");
      navigate("/login");
    } catch (err) { setError(apiError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md animate-fade-up">
        <div className="mb-8 flex justify-center"><Logo size="lg" align="center" /></div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-xl shadow-slate-900/5 p-8">
          <h2 className="font-head text-2xl font-bold text-slate-900">Set new password</h2>
          <p className="text-slate-500 text-sm mt-1 mb-6">Choose a strong password for your account.</p>
          {!token && <div className="bg-amber-50 border border-amber-200 text-amber-700 text-sm rounded-lg px-3.5 py-2.5 mb-4">Missing reset token. Please use the link from your email.</div>}
          {error && <div className="bg-rose-50 border border-rose-200 text-rose-700 text-sm rounded-lg px-3.5 py-2.5 mb-4">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="New password"
              className="w-full bg-slate-50 border border-slate-300 rounded-lg px-3.5 py-2.5 text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
            <input data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required placeholder="Confirm password"
              className="w-full bg-slate-50 border border-slate-300 rounded-lg px-3.5 py-2.5 text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
            <button data-testid="reset-submit" type="submit" disabled={loading || !token} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-xl flex items-center justify-center gap-2 disabled:opacity-60">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Reset password
            </button>
          </form>
          <Link to="/login" className="inline-flex items-center gap-2 text-slate-500 text-sm mt-6 hover:text-slate-700"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
